<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 出荷詳細画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="納品基本情報" name="sendBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 納品No -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.SEND.DELIVERY_NO')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="sendEditForm.sbSendNo"
                      class="commonDialog"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 得意先 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.SEND.CUSTOMER')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="sendEditForm.sbCusCodeShow"
                      :placeholder="$t('message.NUMBER.CLICK_AND_SELECT_HINT')"
                      class="commonDialog"
                      disabled
                      @click.native="customerReferenceClick"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 担当者 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.COMMON_CONSTANT.CONNECTER')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="sendEditForm.sbUserCode"
                      placeholder=""
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.SEND.STATUS')"
                    class="marginBottom"
                  >
                    <t-select
                      v-model="sendEditForm.sbSendStatus"
                      placeholder=""
                      class="commonDialog"
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>

              <t-row type="flex" justify="center">
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 納品日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.SEND.DELIVERY_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="sendEditForm.sbSendDate"
                      type="date"
                      class="dialogDate"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :clearable="false"
                    >
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <!-- 請求予定日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.SEND.REQ_EXPECTED_DATE')"
                    class="marginBottom"
                  >
                    <t-date-picker
                      v-model="sendEditForm.sbRequestExpectedDate"
                      type="date"
                      class="dialogDate"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      disabled
                    />
                  </t-form-item>
                </t-col>

                <!-- 請求状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.SEND.REQ_STATUS')"
                    class="marginBottom"
                    v-show="!localIsAdd"
                  >
                    <t-select
                      v-model="sendEditForm.sbRequestStatus"
                      placeholder=""
                      class="commonDialog"
                      disabled
                    >
                      <t-option
                        v-for="item in requestStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colCom" class="center">
                  <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- 「顧客納品有無」、「納品書有無」は非表示を変更する -->
                  <!-- <template>
                    <t-checkbox
                      v-model="sbSendFlg"
                      :label="$t('resource.SEND.SEND_EXIST_FLG')"
                      style="line-height: 3"
                    />
                    <t-checkbox
                      v-model="sbDeliveryNoteFlg"
                      :label="$t('resource.SEND.DELIVERY_NOTE_EXIST_FLG')"
                      style="line-height: 3"
                    />
                  </template> -->
                  <!-- DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>

              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 備考 -->
                <t-col :span="colArr.colCom * 4">
                  <t-form-item
                    :label="$t('resource.JP_RECEIVE.REMARKS')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="sendEditForm.sbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>

          <t-row>
            <t-col :span="4" class="marginBottom">
              <!-- 出荷製品選択 -->
              <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="selectBtn"
                @click="showSendSelectDialog"
                :disabled="btnSendSelectFlag"
              > -->
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- 課題_「納品製品選択」ボタンの改善 -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="selectBtn"
                @click="showSendSelectDialog"
                :disabled="!localIsAdd"
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="selectBtn"
                @click="showSendSelectDialog"
                :disabled="btnSendSelectFlag"
              >
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->
                <i class="el-icon-s-order"></i>
                {{ $t("resource.SEND.SEND_PROD_SELECT") }}
              </t-button></t-col
            >

            <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓ -->
            <!-- 課題_納期分割機能の追加 -->
            <!-- <t-col :span="16">&nbsp;</t-col> -->
            <t-col :span="12">&nbsp;</t-col>

            <t-col :span="4" class="right">
              <!-- 赤伝票出力 -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="redTicketBtn"
                :disabled="localIsAdd"
                @click="outputRedExcel"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.SEND.RED_DATE_OUTPUT") }}
              </t-button>
            </t-col>
            <!-- UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑ -->

            <t-col :span="4" class="right">
              <!-- 納品書&受領書 -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="outPutBtn"
                :disabled="localIsAdd"
                @click="outPutClick"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.SEND.DELIVERY&RECEIPT_NOTE") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <!-- 出荷詳細 -->
      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_FOUR'))"
          >
            <!-- テーブル -->
            <div>
              <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ -->
              <!-- <t-table
                ref="sendDetailTable"
                :data="sendDetailTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                border
                fit
              > -->
              <t-table
                ref="sendDetailTable"
                :data="sendDetailTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :cell-class-name="tableCellClassName"
                :row-class-name="rowClassName"
                border
                fit
                row-key="id"
                default-expand-all
              >
                <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->
                <!-- テーブルの列 -->
                <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 画面と文字サイズの調整 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->
                <!-- 列固定：「得意先納期」列 -->
                <!-- <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                > -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :fixed="index < 2"
                  :header-align="column.headerAlign"
                  :class-name="`${column.class} input_font_small`"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->

                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                  <template slot-scope="scope">
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->

                    <!-- <t-input
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_custom"
                      :controls="false"
                      :maxlength="6"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                    ></t-input>

                    <t-input
                      v-else-if="
                        column.prop === 'sdRemarks' &&
                        scope.row.sbDelFlg !== '1'
                      "
                      maxLength="200"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.sbDelFlg === '1'"
                    ></t-input> -->

                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 画面と文字サイズの調整 -->
                    <!-- <t-input
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_custom"
                      :controls="false"
                      :maxlength="5"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    ></t-input>

                    <t-input
                      v-else-if="
                        column.prop === 'sdRemarks' &&
                        scope.row.sbDelFlg !== '1'
                      "
                      maxLength="200"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.sbDelFlg === '1'"
                      @focus="selectValue($event)"
                    ></t-input> -->

                    <t-input
                      v-if="editCellData(scope.row, column)"
                      class="cell_input_custom cell_input_font_small"
                      :controls="false"
                      :maxlength="5"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData(scope.row)"
                      @input="
                        scope.row[column.prop] = scope.row[column.prop].replace(
                          /[^\d]/g,
                          ''
                        )
                      "
                      :ref="`input${scope.row.index}-${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    ></t-input>

                    <t-input
                      v-else-if="
                        column.prop === 'sdRemarks' &&
                        scope.row.sbDelFlg !== '1'
                      "
                      maxLength="200"
                      class="cell_input_font_small"
                      v-model="scope.row[column.prop]"
                      :disabled="scope.row.sbDelFlg === '1'"
                      @focus="selectValue($event)"
                    ></t-input>
                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                    <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓ -->
                    <!-- <t-checkbox
                      v-model="scope.row['sdDeliveryNoteOutBool']"
                      v-else-if="column.prop === 'sdDeliveryNoteOut'"
                      @change="noteOutputProc(scope.row)"
                    /> -->
                    <t-checkbox
                      v-model="scope.row['sdDeliveryNoteOutBool']"
                      v-else-if="
                        column.prop === 'sdDeliveryNoteOut' &&
                        scope.row.id < 10000
                      "
                      @change="noteOutputProc(scope.row)"
                    />
                    <!-- UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑ -->
                    <!-- :disabled="scope.row.sbDelFlg === '1'" -->

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>
                <!-- ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓ -->
                <t-table-column
                  :label="$t('resource.DUE_DATE_EDIT.TREATMENT')"
                  :class-name="'cell_txt_center input_font_small'"
                  width="120"
                >
                  <template slot-scope="scope">
                    <!--異常製品追加-->
                    <t-button
                      v-if="scope.row.id < 10000"
                      type="primary"
                      size="small"
                      style="
                        flex-shrink: 0;
                        width: 100px;
                        display: inline-block;
                      "
                      :disabled="localIsAdd"
                      @click="
                        showDueDateEditDialogBeforeProc(scope.row, $event)
                      "
                    >
                      {{ $t("resource.DUE_DATE_EDIT.ERR_PROD_ADD") }}</t-button
                    >
                  </template>
                </t-table-column>
                <!-- ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <!-- ボタン -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row type="flex" justify="end">
          <div>
            <t-col :span="6">&nbsp;</t-col>
            <!-- 本回出荷合計 -->
            <t-col :span="6" class="col_common_right">
              <t-input
                v-model="sendQtySum"
                class="sumInput"
                disabled
                style="margin-right: 10px; margin-top: 5px"
              >
                <template slot="prepend">
                  {{ $t("resource.SEND.SEND_QUANTITY_TOTAL") }}</template
                >
              </t-input>
            </t-col>
            <!-- 出荷残合計 -->
            <t-col :span="6" class="col_common_right">
              <t-input
                v-model="sendRemainSum"
                class="sumInput"
                disabled
                style="margin-right: 10px; margin-top: 5px"
              >
                <template slot="prepend">
                  <span class="span_style">
                    {{ $t("resource.SEND.SEND_REMAIN_TOTAL") }}</span
                  ></template
                >
              </t-input>
            </t-col>

            <!-- 金額合計 -->
            <t-col :span="6" lass="col_common_right">
              <t-input
                v-model="amountTotal"
                disabled
                style="margin-top: 5px"
                class="sumInput"
              >
                <template slot="prepend">
                  <span class="span_style">
                    {{ $t("resource.SEND.AMOUNT_TOTAL") }}</span
                  ></template
                >
              </t-input>
            </t-col>
          </div>
        </t-row>
        <t-row>
          <div>
            <!-- DEL 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓ -->
            <!-- 課題_納期分割機能の追加 -->

            <!-- 納品異常 -->
            <!-- <t-col :span="4" align="left">
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                @click="sendErrorDialogProc()"
                ref="sendErrBtn"
                :disabled="localIsAdd"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.SEND.DELIVERY_ERROR") }}</t-button
              >
            </t-col>

            <t-col :span="16">&nbsp;</t-col> -->
            <!-- DEL 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑ -->
            <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
            <!-- 「再度納品」機能の追加 -->
            <!-- <t-col :span="24" align="right"> -->

            <!-- 再度納品ボタン -->
            <t-col :span="21" align="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="sendAgain"
                v-show="!localIsAdd"
                ref="sendAgainBtn"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.SEND.SEND_AGAIN") }}</t-button
              >
            </t-col>

            <!-- 確定ボタン -->
            <t-col :span="localIsAdd ? 24 : 3" align="right">
              <!-- UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑ -->

              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="sendConfirm"
                :disabled="confirmBtnFlg"
                ref="confirmBtn"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import {
  ShowCustomerReferenceDialog,
  ShowDueDateEditDialog,
  ShowSendSelectDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import { outputExcelToZip, updateStatusAfterOutput } from "@/services/common";
import {
  addSendDetail,
  getCusCalculateDate,
  getSendSelect,
  initSendSearchList,
  searchSendDetailByNo,
  updateSendDetail,
} from "@/services/send";
import {
  DIALOG_LINE_HEIGHT,
  NUM_TWO,
  NUM_ZERO,
  STR_BACKSLASH,
  STR_COLON,
  STR_EMPTY,
  STR_FIVE,
  STR_HYPHEN,
  STR_ONE,
  STR_TWELVE,
  STR_ZERO,
  STR_ZERO_ONE,
} from "@/utils/const";

import {
  cmpBasicData,
  cmpDetailData,
  formatCurDateToString,
  formatCurrencyToNumber,
  formatDateStrToString,
  formatDateToString,
  formatStringToCurrency,
  formatUndefinedToDate,
  getAbleUserInfoList,
  getEditColWidthArr,
} from "@/utils/comFunction";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["sendBasic"],
      // 出荷状態リスト
      statusList: [],
      // 請求状態
      requestStatusList: [],
      // 得意先リスト
      customerInfoList: [],
      // 担当者リスト
      connecterList: [],
      // true:納品書&受領書ボタンをクリックできない  false:納品書&受領書ボタンをクリックできる
      buttonClickFlag: false,
      // 出荷製品選択ボタン使用フラグ
      btnSendSelectFlag: false,
      // 確定ボタン使用フラグ
      confirmBtnFlg: true,

      localIsAdd: this.isAdd,

      editableColumns: ["sdSendQty", "sdDeliveryNoteOut", "sdRemarks"],

      selectedSearchForm: "", // 出荷製品選択画面の検索条件

      // errorSearchForm: "", // 出荷異常画面の検索条件

      sendEditForm: {
        sbSendNo: "", //納品No
        sbCusCodeShow: "", //得意先
        sbCusCode: "", //得意先
        sbUserCode: "", //担当者
        sbSendStatus: "", //状態

        sbSendDate: "", //納品日
        sbRequestExpectedDate: "", // 請求予定日
        sbRequestStatus: "", // 請求状態
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_納品製品選択画面の検索条件の変更
        // sbSendFlg: "", //顧客出荷有無
        // sbDeliveryNoteFlg: "", // 納品書有無
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        sbRemarks: "", // 備考
        sbUpdateUser: "", // 担当者
        sbUpdateTime: "", //更新者
        sbUpdateTime: "", //更新時刻
      },

      sendQtySum: 0, //本回出荷合計
      sendRemainSum: 0, //出荷残合計
      amountTotal: 0, //金額合計

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_納品製品選択画面の検索条件の変更
      // sbSendFlg: false, // 顧客出荷有無のチェックボックス
      // sbDeliveryNoteFlg: false, // 納品書有無のチェックボックス
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      isSelected: false, // 納品書出力のチェックボックス

      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // 赤伝票データ
      sendErrCloseData: {},
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      //出荷基本情報(データ保存用)
      sendBasicData: {},
      //出荷詳細情報(データ保存用)
      sendDetailData: [
        {
          sdSendNo: "", // 出荷No.
          sdSendDetailNo: "", // 出荷明細No.
          sdSendQty: "", // 出荷数量
          sdUSalesPrice: "", // 売価
          sdUSalesPriceShow: "", // 売価(表示)
          sdTotalSales: "", // 小計
          sdTotalSalesShow: "", // 小計(表示)

          sdDeliveryNoteOut: "", //納品書出力 0：チェックしない　1：チェックする
          sdDeliveryNgQty: "", //納品NG数
          sdRemarks: "", //備考
          sdProdExQty: "", //異常件数
          sdProdExKbn: "", // 製品異常区分

          sdProdSuppPayQty: "", //補足支払数.
          sdCloseState: "", // クローズ状態 0：未クローズ、1：クローズ

          sdOrderNo: "", // 注文No. 注文基本情報_注文No.
          sdDetailNo: "", // 注文明細No. 注文明細_注文明細No.
          sdQuoteNo: "", // 見積No. 受注基本情報_見積No.
          sdProdNo: "", // 受注明細No. 受注明細_受注明細No.
        },
      ],

      // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
      //「一式データ」且 異常データを存在し場合:true
      exProdFlgASet: false,

      // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑

      sdDeliveryNoteData: [],

      //出荷詳細一覧(テーブルデータ表示用)
      sendDetailTable: [],

      //
      oldCusCode: "",

      //出荷詳細テーブル一覧項目
      columns: [
        {
          // 見積No.
          prop: "sdQuoteNo",
          label: t("resource.SEND.ESTIMATED_NO"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "aobCusDeliveryDate",
          prop: "aodCusDeliveryDate",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.SEND.CUS_DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 得意先納品先
        {
          prop: "aodCusDelvName",
          label: t("resource.ACCEPT_ORDER.DELI_ADDR"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ関連区分
        {
          prop: "aodMisumiKbnStr",
          label: t("resource.ORDER.MSM_KBN"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
        },
        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.SEND.PRODUCT_NAME"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.SEND.PRODUCT_DRAW_NO"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 受注数
        {
          prop: "aodProdQuantity",
          label: t("resource.SEND.ACCEPT_ORDER_NUM"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.SEND.PRODUCT_UNIT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },

        // 運送中
        {
          prop: "transportingQty",
          label: t("resource.SEND.TRANSPORTING"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 日本入荷数
        {
          prop: "jrdReceQty",
          label: t("resource.SEND.OFFICER_RECEIVE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 出荷完了
        {
          prop: "sdProCompleteNum",
          label: t("resource.SEND.SEND_COMPLETE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 本回納品数
        {
          prop: "sdSendQty",
          label: t("resource.SEND.SEND_QUANTITY"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 未納品
        {
          prop: "disSendNum",
          label: t("resource.SEND.DIS_DELIVERY"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 出荷残
        {
          prop: "sdSendRemainQty",
          label: t("resource.SEND.SEND_REMAIN_QUANTITY"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 売価
        {
          prop: "sdUSalesPriceShow",
          label: t("resource.SEND.SALES_PRICE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 小計
        {
          prop: "sdTotalSalesShow",
          label: t("resource.SEND.SUBTOTAL"),
          width: 120,
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 納品書出力
        {
          prop: "sdDeliveryNoteOut",
          label: t("resource.SEND.NOTE_OUTPUT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },

        // // 備考
        // {
        //   prop: "sdRemarks",
        //   label: t("resource.SEND.REMARKS"),
        //   // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   width: t("widgetSize.tableCommon.colMaxWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
      ],

      showFlag: false,

      //基本情報のheight
      //49: collapseのheight 45: 輸送方式のheight　45：目的地　65：備考　45：ボタン
      basicHeight: 49 + 45 + 45 + 65 + 45,
      //明細情報のheight  (window.innerHeight * (1 - 0.1) - 65): 画面のheight
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      // detailHeight:
      //   window.innerHeight * (1 - 0.1) -
      //   65 -
      //   (49 + 45 + 45 + 65 + 45) -
      //   DIALOG_LINE_HEIGHT * 2 -
      //   25,
      detailHeight:
        window.innerHeight * (1 - 0.01) -
        65 -
        (49 + 45 + 45 + 65 + 45) -
        DIALOG_LINE_HEIGHT * 2 -
        25,
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 2,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),
      cusCalculateDate: 0,

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
    };
  },

  props: {
    //true:新規作成　false:編集
    isAdd: {
      Type: Boolean,
      default: false,
    },
    //行データ
    rowData: {
      Type: Object,
    },
  },

  watch: {
    "sendEditForm.sbSendDate"(newVal, oldVal) {
      if (!this.cusCalculateDate) {
        this.getCusCalculateDateProc();
      } else {
        this.sendEditForm.sbRequestExpectedDate = this.setReqExceptDate();
      }
    },
  },

  mounted() {
    //画面情報初期化
    this.init(this.rowData);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("sendBasic") !== -1) {
        this.basicHeight = 49 + 45 + 45 + 65 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45 + 45 + 65 + 45) -
        //   DIALOG_LINE_HEIGHT * 2 -
        //   25;
        this.detailHeight =
          window.innerHeight * (1 - 0.01) -
          65 -
          (49 + 45 + 45 + 65 + 45) -
          DIALOG_LINE_HEIGHT * 2 -
          25;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      } else {
        this.basicHeight = 49 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45) -
        //   DIALOG_LINE_HEIGHT * 2 -
        //   20;
        this.detailHeight =
          window.innerHeight * (1 - 0.01) -
          65 -
          (49 + 45) -
          DIALOG_LINE_HEIGHT * 2 -
          20;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }
      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      //出荷情報の初期化
      this.infoInit(data);

      //列幅に自動調整
      // setColumnWidth(this.columns, this.sendDetailTable);
    },

    //出荷情報の初期化
    infoInit(data) {
      // 検索条件リストの初期化(有無状態、請求状態、出荷状態、得意先リスト、ユーザーリスト、仕入先リスト)
      initSendSearchList()
        .then((res) => {
          // 出荷状態リストのクリア
          this.statusList = res.sendStatusList;
          // 請求状態
          this.requestStatusList = res.requestStatusList;
          // 担当者リスト
          this.connecterList = res.userCodeList;
          // 得意先リスト
          this.customerInfoList = res.customerInfoList;

          //初期値の設定
          this.setInitValue(data);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
          this.showFlag = false;
        });
    },

    // 初期値の設定
    setInitValue(data) {
      // 新規作成の場合
      if (this.localIsAdd) {
        this.activeNames = ["sendBasic"];
        this.handleCollapseChange(this.activeNames);

        //納品日:システム日
        this.sendEditForm.sbSendDate = new Date();
        // 状態：新規
        this.sendEditForm.sbSendStatus = STR_ONE;
        // 担当者
        this.sendEditForm.sbUserCode = getUserInfo().UserId;
        this.getAbleList();
        // 「納品書&受領書」ボタンは使用できません
        // this.buttonClickFlag = true;
        this.confirmBtnFlg = true;

        // 請求状態：請求台帳機能でこの状態を更新する
        this.sendEditForm.sbRequestStatus = STR_ONE;
        this.showFlag = false;
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);

        // 納品No
        this.sendEditForm.sbSendNo = data.sbSendNo;
        // 「納品書&受領書」ボタンを使用可能にする
        // this.buttonClickFlag = false;
        this.confirmBtnFlg = false;
        // 注文No.による注文詳細情報の取得
        this.searchSendDetailByNoProc();
      }
    },

    // 使用可能な担当者リスト、得意先リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.sendEditForm.sbUserCode
      );

      // // 得意先リスト
      // this.customerInfoList = getAbleCusMstInfoList(
      //   this.customerInfoList,
      //   this.sendEditForm.sbCusCode
      // );
    },

    //出荷No.による出荷詳細情報の取得
    searchSendDetailByNoProc() {
      // ADD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
      if (!this.showFlag) {
        this.showFlag = true;
      }
      // ADD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑

      // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //searchSendDetailByNo({ sendBasicForm: this.sendEditForm })
      //検索フラグselectFlg 　1:納品詳細画面　　2：納品異常処理画面
      searchSendDetailByNo({ sendBasicForm: this.sendEditForm, selectFlg: "1" })
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        .then((res) => {
          // 出荷編集情報を表示
          this.sendEditForm = res.sendBasicForm;
          // 出荷詳細テーブル情報を表示
          this.sendDetailTable = res.sendDetailList;

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          // 赤伝票データ
          this.sendErrCloseData = res.sendErrCloseData;
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

          this.oldCusCode = this.sendEditForm.sbCusCode;

          this.getAbleList();

          //書式処理
          this.basicDataProcess();
          //列幅に自動調整
          // setColumnWidth(this.columns, this.sendDetailTable);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    basicDataProcess() {
      if (!!this.sendEditForm) {
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_納品製品選択画面の検索条件の変更
        // if (!!!this.sendEditForm.sbSendFlg) {
        //   this.sendEditForm.sbSendFlg = STR_ZERO;
        // }
        // this.sendEditForm.sbSendFlg = this.sendEditForm.sbSendFlg;
        // if (this.sendEditForm.sbSendFlg == STR_ONE) {
        //   this.$nextTick(() => {
        //     this.sbSendFlg = true;
        //   });
        // } else {
        //   this.$nextTick(() => {
        //     this.sbSendFlg = false;
        //   });
        // }
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        this.sendEditForm.sbSendDate = formatUndefinedToDate(
          this.sendEditForm.sbSendDate
        );

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_納品製品選択画面の検索条件の変更
        // if (!!!this.sendEditForm.sbDeliveryNoteFlg) {
        //   this.sendEditForm.sbDeliveryNoteFlg = STR_ZERO;
        // }

        // // 納品書有無
        // if (this.sendEditForm.sbDeliveryNoteFlg == STR_ONE) {
        //   this.$nextTick(() => {
        //     this.sbDeliveryNoteFlg = true;
        //   });
        // } else {
        //   this.$nextTick(() => {
        //     this.sbDeliveryNoteFlg = false;
        //   });
        // }
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // UPD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
        // // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // // 課題_「納品製品選択」ボタンの改善
        // // 異常データを存在し、または納品データを請求した場合、クリック不可
        // // if (this.sendEditForm.sbDelFlg === STR_ONE) {

        // if (
        //   this.sendEditForm.sbDelFlg === STR_ONE ||
        //   this.sendEditForm.exProdFlg === STR_ONE
        // ) {
        //   // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        //   this.btnSendSelectFlag = true;
        // } else {
        //   this.btnSendSelectFlag = false;
        // }

        //「納品製品選択」ボタンの改善
        //1.納品データを請求した場合 または「一式」以外データの異常データを存在し場合、クリック不可
        if (
          this.sendEditForm.sbDelFlg === STR_ONE ||
          (this.sendDetailTable.length > 0 &&
            this.sendDetailTable[0]["aobASet"] != STR_ONE &&
            this.sendEditForm.exProdFlg === STR_ONE)
        ) {
          this.btnSendSelectFlag = true;
        }
        //2.納品データを請求しない場合 且「一式」データの異常データを存在し場合、クリック可
        else if (
          this.sendDetailTable.length > 0 &&
          this.sendDetailTable[0]["aobASet"] == STR_ONE &&
          this.sendEditForm.exProdFlg === STR_ONE
        ) {
          this.btnSendSelectFlag = false;
          this.exProdFlgASet = true;
        }
        // その他場合、クリック可
        else {
          this.btnSendSelectFlag = false;
        }
        // UPD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
      }

      if (this.sdDeliveryNoteData.length > 0) {
        for (let index = 0; index < this.sendDetailTable.length; index++) {
          const item = this.sendDetailTable[index];

          item.sdDeliveryNoteOutBool = this.sdDeliveryNoteData[index];
        }
      } else {
        for (let index = 0; index < this.sendDetailTable.length; index++) {
          const item = this.sendDetailTable[index];

          if (item.sdProdExKbn === STR_ZERO) {
            item.sdDeliveryNoteOutBool = true;
          } else {
            item.sdDeliveryNoteOutBool = false;
          }
          this.sdDeliveryNoteData[index] = item.sdDeliveryNoteOutBool;
        }
      }

      this.dataProcess();
    },

    //データの変換処理
    dataProcess() {
      //本回出荷合計のクリア
      this.sendQtySum = NUM_ZERO;
      //金額合計のクリア
      this.amountTotal = NUM_ZERO;
      //出荷残合計のクリア
      this.sendRemainSum = NUM_ZERO;

      let detailResult = [];

      if (this.sendDetailTable.length >= 1) {
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // for (let index = 0; index < this.sendDetailTable.length; index++) {
        //   const item = this.sendDetailTable[index];
        this.sendDetailTable.map((item, index) => {
          // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

          // if (item.sdProdExKbn === STR_ZERO) {
          //   item.sdDeliveryNoteOutBool = true;
          // } else {
          //   item.sdDeliveryNoteOutBool = false;
          // }

          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // 得意先納期が空のチェック
          // if (typeof item.aobCusDeliveryDate === "undefined") {
          //   item.aobCusDeliveryDate = STR_EMPTY;
          // } else {
          //   item.aobCusDeliveryDate = formatDateStrToString(
          //     item.aobCusDeliveryDate
          //   );
          // }
          // 得意先納期が空のチェック
          if (typeof item.aodCusDeliveryDate === "undefined") {
            item.aodCusDeliveryDate = STR_EMPTY;
          } else {
            item.aodCusDeliveryDate = formatDateStrToString(
              item.aodCusDeliveryDate
            );
          }
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          //受注日が空のチェック
          if (typeof item.aobAcceptDate === "undefined") {
            item.aobAcceptDate = STR_EMPTY;
          } else {
            item.aobAcceptDate = formatDateStrToString(item.aobAcceptDate);
          }

          //加工単価が数字の場合
          if (!isNaN(item.sdUSalesPrice)) {
            if (item.sdProdExKbn === STR_ZERO) {
              // 小計
              item.sdTotalSales = item.sdUSalesPrice * item.sdSendQty;
              item.sdTotalSalesShow = formatStringToCurrency(
                item.sdUSalesPrice * item.sdSendQty
              );
              // 売価
              item.sdUSalesPriceShow = formatStringToCurrency(
                item.sdUSalesPrice
              );
            } else {
              item.sdTotalSalesShow = STR_HYPHEN;
              item.sdUSalesPriceShow = STR_HYPHEN;
            }

            //金額合計
            if (!!!this.amountTotal || this.amountTotal == STR_EMPTY) {
              this.amountTotal = NUM_ZERO;
            }
            if (!!item.sdTotalSales && item.sdTotalSales != NUM_ZERO) {
              this.amountTotal = formatStringToCurrency(
                formatCurrencyToNumber(this.amountTotal) + item.sdTotalSales
              );
            }
          } else {
            //売価が数字以外の場合、0に表示する
            item.sdUSalesPrice = 0;
            item.sdTotalSalesShow = formatStringToCurrency(0);
            item.sdTotalSales = 0;
          }

          // 運送中
          item.transportingQty = this.checkNull(item.transportingQty);
          // 日本入荷数
          item.jrdReceQty = this.checkNull(item.jrdReceQty);
          // 出荷完了
          item.sdProCompleteNum = this.checkNull(item.sdProCompleteNum);

          // 未出荷: 運送中+事務所入荷-出荷完了の合計-本回出荷数
          item.disSendNum =
            item.transportingQty +
            item.jrdReceQty -
            item.sdProCompleteNum -
            item.sdSendQty;

          if (item.sdProdExKbn == STR_ZERO) {
            // 出荷残：受注数-出荷完了数-本回出荷数
            item.sdSendRemainQty =
              item.aodProdQuantity - item.sdProCompleteNum - item.sdSendQty;
          } else {
            item.sdSendRemainQty = NUM_ZERO;
          }

          //本回出荷合計
          if (!!!this.sendQtySum || this.sendQtySum == STR_EMPTY) {
            this.sendQtySum = NUM_ZERO;
          }
          if (!!item.sdSendQty) {
            item.sdSendQty = parseInt(item.sdSendQty);
            this.sendQtySum += item.sdSendQty;
          }

          //出荷残合計
          if (!!!this.sendRemainSum || this.sendRemainSum == STR_EMPTY) {
            this.sendRemainSum = NUM_ZERO;
          }
          if (!!item.sdSendRemainQty) {
            this.sendRemainSum = this.sendRemainSum + item.sdSendRemainQty;
          }

          // item.index = index;
          detailResult.push(JSON.parse(JSON.stringify(item)));
        });
      }

      // 読み込み回数 = 1
      if (!this.localIsAdd && this.numLoads == 1) {
        this.$nextTick(() => {
          // 比較用基本情報
          this.cmpBasicResult = JSON.parse(
            JSON.stringify(this.extractBasic(this.sendEditForm))
          );
        });

        // 比較用明細情報
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // this.cmpDetailResult = JSON.parse(JSON.stringify(detailResult));
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extractDetail(detailResult))
        );
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    //「確定」ボタン
    sendConfirm() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      for (let index = 0; index < this.sendDetailTable.length; index++) {
        const element = this.sendDetailTable[index];

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // if (
        //   element.sdSendQty <= 0 ||
        //   element.sdSendQty >
        //     element.transportingQty +
        //       element.jrdReceQty -
        //       element.sdProCompleteNum
        // ) {
        //   let message =
        //     "製品「" +
        //     element.aodProdName +
        //     "」の" +
        //     t("message.SEND.SEND_QTY_CHECK");
        //   Modal.showWarning("", message, {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //   });
        //   this.showFlag = false;
        //   return;
        // }

        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 納品数＞受注数・納品数？＞運送中数＋日本入荷数の場合、保存後、日本入荷データと入荷異常データ履歴を影響
        // 納品数＜受注数・納品数<運送中数＋日本入荷数のチェックの追加
        // if (element.sdSendQty <= 0) {
        if (
          element.sdSendQty <= 0 ||
          element.disSendNum < 0 ||
          element.sendRemainSum < 0
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.SEND.SEND_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          this.showFlag = false;
          return;
        }

        //納品NG数<納品数
        if (element.sdSendQty - element.sdProdExQty < 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.SEND.CONFIRM_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // if (this.sendDetailTable.length >= 1) {
      //   if (this.localIsAdd) {
      //     //注文台帳新規作成
      //     this.addSendDetailProc();
      //   } else {
      //     //注文台帳編集保存
      //     this.updateSendDetailProc();
      //   }
      // } else {
      //   Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
      //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //   });
      //   this.showFlag = false;
      // }

      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 納品数＞受注数・納品数？＞運送中数＋日本入荷数の場合、保存後、日本入荷データと入荷異常データ履歴を影響
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      //未納品<0
      // let disSendQtyFlg = this.sendDetailTable.some(function (item) {
      //   return item.disSendNum < 0;
      // });

      // if (disSendQtyFlg) {
      //   let message = t("message.SEND.NOT_SEND_QTY_CONFIRM");
      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.acceptQtyCheck();
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      //   this.acceptQtyCheck();
      // }
      // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

      if (this.sendDetailTable.length >= 1) {
        if (this.localIsAdd) {
          //注文台帳新規作成
          this.addSendDetailProc();
        } else {
          //注文台帳編集保存
          this.updateSendDetailProc();
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        this.showFlag = false;
      }

      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      // //出荷残<0
      // let disSendNumCheckFlg = this.sendDetailTable.some(function (item) {
      //   return item.sdSendRemainQty < 0;
      // });

      // if (disSendNumCheckFlg) {
      //   let message = t("message.SEND.DIS_SEND_QTY_CONFIRM");

      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.saveDataProc();
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      //   this.saveDataProc();
      // }
      // DEL 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }
    },

    // DEL 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    // 納品数＞受注数・納品数？＞運送中数＋日本入荷数の場合、保存後、日本入荷データと入荷異常データ履歴を影響
    // 納品数＜受注数・納品数<運送中数＋日本入荷数のチェックの追加

    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    // acceptQtyCheck() {
    //   //出荷残<0
    //   let disSendNumCheckFlg = this.sendDetailTable.some(function (item) {
    //     return item.sdSendRemainQty < 0;
    //   });

    //   if (disSendNumCheckFlg) {
    //     let message = t("message.SEND.DIS_SEND_QTY_CONFIRM");

    //     Modal.showWarning("", message, {
    //       $type: "prompt",
    //       confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
    //       cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
    //       showCancelButton: true,
    //     })
    //       .then(() => {
    //         this.saveDataProc();
    //       })
    //       .finally(() => {
    //         if (this.showFlag) {
    //           this.showFlag = false;
    //         }
    //       });
    //   } else {
    //     this.saveDataProc();
    //   }
    // },

    // outputAcceptQtyCheck(kbn) {
    //   if (!this.showFlag) {
    //     this.showFlag = true;
    //   }

    //   //出荷残<0
    //   let disSendNumCheckFlg = this.sendDetailTable.some(function (item) {
    //     return item.sdSendRemainQty < 0;
    //   });

    //   if (disSendNumCheckFlg) {
    //     let message = t("message.SEND.DIS_SEND_QTY_CONFIRM");

    //     Modal.showWarning("", message, {
    //       $type: "prompt",
    //       confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
    //       cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
    //       showCancelButton: true,
    //     })
    //       .then(() => {
    //         this.saveDataAndOutput(kbn);
    //       })
    //       .finally(() => {
    //         if (this.showFlag) {
    //           this.showFlag = false;
    //         }
    //       });
    //   } else {
    //     this.saveDataAndOutput(kbn);
    //   }
    // },
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    // DEL 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    saveDataProc() {
      if (this.sendDetailTable.length >= 1) {
        if (this.localIsAdd) {
          //注文台帳新規作成
          this.addSendDetailProc();
        } else {
          //注文台帳編集保存
          this.updateSendDetailProc();
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        this.showFlag = false;
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_納品製品選択画面の検索条件の変更
      // if (this.sbSendFlg) {
      //   this.sendEditForm.sbSendFlg = STR_ONE;
      // } else {
      //   this.sendEditForm.sbSendFlg = STR_ZERO;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      this.sendEditForm.sbSendDate = formatCurDateToString(
        this.sendEditForm.sbSendDate
      );

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_納品製品選択画面の検索条件の変更
      // if (this.sbDeliveryNoteFlg) {
      //   this.sendEditForm.sbDeliveryNoteFlg = STR_ONE;
      // } else {
      //   this.sendEditForm.sbDeliveryNoteFlg = STR_ZERO;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // 更新者
      this.sendEditForm.sbUpdateUser = getUserInfo().UserId;

      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // this.sendDetailData = this.sendDetailTable;
      this.sendDetailData = this.sendDetailTable.filter(
        (item) => item.id < 10000
      );
      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      for (let index = 0; index < this.sendDetailData.length; index++) {
        const element = this.sendDetailData[index];
        element.sdSendNo = this.sendEditForm.sbSendNo; // 出荷No.
        element.sdSendDetailNo = index + 1; // 出荷明細No.
        element.sdCloseState = element.sdCloseStateBool ? 1 : 0; //納品書出力 0：チェックしない　1：チェックする

        if (!element.sdCloseState || element.sdCloseState == null) {
          element.sdCloseState = NUM_ZERO;
        }
      }
    },

    // 出荷基本情報と明細情報の新規追加
    addSendDetailProc() {
      //保存前、データ処理
      this.dataAddUpdProc();

      addSendDetail({
        sendBasicForm: this.sendEditForm,
        sendDetailList: this.sendDetailData,
      })
        .then((res) => {
          //新規⇒編集状態の変換
          this.localIsAdd = false;
          this.sendEditForm.sbSendNo = res;
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          //検索処理を行う
          this.searchSendDetailByNoProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
        });
    },

    // 注文詳細情報の更新
    updateSendDetailProc() {
      //保存前、データ処理
      this.dataAddUpdProc();

      updateSendDetail({
        sendBasicForm: this.sendEditForm,
        sendDetailList: this.sendDetailData,
      })
        .then((res) => {
          this.numLoads = 1;

          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          //検索処理を行う
          this.searchSendDetailByNoProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    // 出荷製品選択画面を表示
    showSendSelectDialog() {
      if (
        !!!this.sendEditForm.sbCusCode ||
        this.sendEditForm.sbCusCode == STR_EMPTY
      ) {
        Modal.showWarning("", t("message.SEND.CUS_INPUT_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }

      ShowSendSelectDialog(
        {
          sbCusCode: this.sendEditForm.sbCusCode,
          tableData: this.sendDetailTable,
          selectedSearchForm: this.selectedSearchForm,
          sbSendNo: this.sendEditForm.sbSendNo,
          // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 start↓
          exProdFlgASet: this.exProdFlgASet,
          // ADD 2026/02/12 Wjx 課題_260212顧客からの改善したい点への対応 end↑
        },
        t("resource.SEND.SEND_PROD_SELECT_DIALOG"),
        (target) => {
          if (!!target) {
            //運送製品選択画面の検索条件
            this.selectedSearchForm = target.searchConditionForm;

            getSendSelect({
              sendDetailList: target.selectedProcForm,
              sbSendNo: this.sendEditForm.sbSendNo,
            })
              .then((res) => {
                let sendDetailTable = this.sendDetailTable;
                let sendSelectData = res.sendDetailList;

                sendSelectData.forEach((item) => {
                  let existingProductIndex = sendDetailTable.findIndex(
                    (p) =>
                      p.sdQuoteNo == item.sdQuoteNo &&
                      p.sdProdNo == item.sdProdNo &&
                      p.sdOrderNo == item.sdOrderNo &&
                      p.sdDetailNo == item.sdDetailNo
                  );

                  if (existingProductIndex == -1) {
                    if (item.sdProdExKbn === STR_ZERO) {
                      item.sdDeliveryNoteOutBool = true;
                    } else {
                      item.sdDeliveryNoteOutBool = false;
                    }

                    this.sendDetailTable.push(item);
                  } else {
                    sendDetailTable[existingProductIndex].sdProCompleteNum =
                      item.sdProCompleteNum;
                    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                    sendDetailTable[existingProductIndex].id = item.id;
                    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                  }
                });

                this.sendDetailTable = this.sendDetailTable.filter((p) =>
                  sendSelectData.some(
                    (t) =>
                      p.sdQuoteNo == t.sdQuoteNo &&
                      p.sdProdNo == t.sdProdNo &&
                      p.sdOrderNo == t.sdOrderNo &&
                      p.sdDetailNo == t.sdDetailNo
                  )
                );
                // ADD 2026/03/13 Wjx 課題_260228顧客からの改善したい点への対応 start↓
                //すべて場合、並び順は見積No.(升序)です
                const sorted = [];
                for (const refItem of res.sendDetailList) {
                  const foundItem = this.sendDetailTable.find(
                    (item) => item.id === refItem.id
                  );
                  if (foundItem) {
                    sorted.push(foundItem);
                  }
                }
                this.sendDetailTable = sorted;
                // ADD 2026/03/13 Wjx 課題_260228顧客からの改善したい点への対応 end↑
                for (
                  let index = 0;
                  index < this.sendDetailTable.length;
                  index++
                ) {
                  const element = this.sendDetailTable[index];
                  this.sdDeliveryNoteData[index] =
                    element.sdDeliveryNoteOutBool;
                }

                this.dataProcess();

                this.confirmBtnFlg = false;

                // setColumnWidth(this.columns, this.sendDetailTable);
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });
          }
        }
      );

      if (typeof this.$refs.selectBtn !== "undefined") {
        // フォーカス削除
        this.$refs.selectBtn.$el.blur();
      }
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //参照ボタン
    customerReferenceClick() {
      var arr = this.sendEditForm.sbCusCodeShow.split(STR_COLON);
      var sbCusCode = arr.length > 0 ? arr[0] : STR_EMPTY;

      // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
      //「再度納品」機能の追加
      // if (!(this.isAdd && this.localIsAdd)) {
      //   return;
      // }

      //編集の場合、処理を行わない
      if (!this.localIsAdd) {
        return;
      }
      // UPD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑

      ShowCustomerReferenceDialog(
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 「得意先選択画面」の検索条件の追加
        // { cusCode: sbCusCode },
        {
          cusCode: sbCusCode,
          sendFlg: true,
          searchCusForm: this.selectedSearchForm,
        },
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        t("resource.numberEditInfo.customerReferenceView"),
        (target) => {
          if (!!target) {
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // this.sendEditForm.sbCusCodeShow = target;
            // this.sendEditForm.sbCusCode = target.split(STR_COLON)[0];
            this.sendEditForm.sbCusCodeShow = target.cusInfo;
            this.sendEditForm.sbCusCode = target.cusInfo.split(STR_COLON)[0];
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            if (this.oldCusCode !== this.sendEditForm.sbCusCode) {
              this.sendDetailTable = [];
              this.oldCusCode = this.sendEditForm.sbCusCode;
            }

            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            this.selectedSearchForm = target.searchConditionForm;
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

            this.getCusCalculateDateProc();
          }
        }
      );
    },

    // 得意先締め日の取得
    getCusCalculateDateProc() {
      if (!this.sendEditForm.sbCusCodeShow) {
        return;
      }
      const cusCode = this.sendEditForm.sbCusCodeShow.split(STR_COLON);
      getCusCalculateDate({ sbCusCode: cusCode[0] }).then((res) => {
        this.cusCalculateDate = res.cusCalculateDate;
        this.sendEditForm.sbRequestExpectedDate = this.setReqExceptDate();
      });
    },

    //請求予定日の取得
    setReqExceptDate() {
      let sendDate = new Date(this.sendEditForm.sbSendDate);
      const [sendYear, sendMonth, sendDay] =
        formatDateToString(sendDate).split(STR_BACKSLASH);
      let cusCalculateDate = parseInt(this.cusCalculateDate);

      //年
      var year = sendDate.getFullYear();

      // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
      var month = sendDate.getMonth() + 1;
      // 現在の月の最大日数を取得
      const lastDayOfMonth = new Date(year, month, 0).getDate();
      // ADD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑

      if (sendDay > cusCalculateDate) {
        // UPD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
        // var month = (sendDate.getMonth() + 1).toString();
        month = (sendDate.getMonth() + 1).toString();
        // UPD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑
        if (month === STR_TWELVE) {
          year++;
          month = STR_ZERO_ONE;
        } else {
          month = (sendDate.getMonth() + 2).toString().padStart(2, STR_ZERO);
        }
      } else {
        //月(date.getMonth(): 0~11)
        // UPD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
        // var month = (sendDate.getMonth() + 1).toString().padStart(2, STR_ZERO);
        month = (sendDate.getMonth() + 1).toString().padStart(2, STR_ZERO);
        // UPD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑
      }

      // UPD 2025/02/26 ZLL 課題_納品請求予定日の検討 start↓
      // return (
      //   year + STR_BACKSLASH + month + STR_BACKSLASH + this.cusCalculateDate
      // );
      if (lastDayOfMonth < cusCalculateDate) {
        // 現在の月の最終日に設定
        cusCalculateDate = lastDayOfMonth;
      }
      return year + STR_BACKSLASH + month + STR_BACKSLASH + cusCalculateDate;
      // UPD 2025/02/26 ZLL 課題_納品請求予定日の検討 end↑
    },

    // 「納品書&受領書」ボタン
    outPutClick() {
      if (typeof this.$refs.outPutBtn !== "undefined") {
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      }
      if (!this.showFlag) {
        this.showFlag = true;
      }
      if (!this.sendDetailTable || this.sendDetailTable.length <= 0) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        this.showFlag = false;
        return;
      }
      for (let index = 0; index < this.sendDetailTable.length; index++) {
        const element = this.sendDetailTable[index];
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // if (
        //   element.sdSendQty <= 0 ||
        //   element.sdSendQty >
        //     element.transportingQty +
        //       element.jrdReceQty -
        //       element.sdProCompleteNum
        // ) {
        //   let message =
        //     "製品「" +
        //     element.aodProdName +
        //     "」の" +
        //     t("message.SEND.SEND_QTY_CHECK");
        //   Modal.showWarning("", message, {
        //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //   });
        //   this.showFlag = false;
        //   return;
        // }

        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 納品数＞受注数・納品数？＞運送中数＋日本入荷数の場合、保存後、日本入荷データと入荷異常データ履歴を影響
        // 納品数＜受注数・納品数<運送中数＋日本入荷数のチェックの追加
        // if (element.sdSendQty <= 0) {
        if (
          element.sdSendQty <= 0 ||
          element.disSendNum < 0 ||
          element.sendRemainSum < 0
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.SEND.SEND_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          this.showFlag = false;
          return;
        }

        //納品NG数<納品数
        if (element.sdSendQty - element.sdProdExQty < 0) {
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.SEND.CONFIRM_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        let existData = this.sendDetailTable.filter(
          (item) => item.sdDeliveryNoteOutBool
        );
        if (!existData || existData.length <= 0) {
          Modal.showWarning("", t("message.SEND.DELIVERY_OUTPUT_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          this.showFlag = false;
          return;
        }
      }

      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      //保存前、データ処理
      // this.dataAddUpdProc();

      // if (this.localIsAdd) {
      //   //注文台帳新規作成
      //   addSendDetail({
      //     sendBasicForm: this.sendEditForm,
      //     sendDetailList: this.sendDetailData,
      //   })
      //     .then((res) => {
      //       //新規⇒編集状態の変換
      //       this.localIsAdd = false;
      //       this.sendEditForm.sbSendNo = res;
      //       Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
      //       this.outputProcess();
      //     })
      //     .catch((err) => {
      //       this.showFlag = false;
      //       if (err.data != null) {
      //         Message.showError(
      //           t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
      //         );
      //       } else {
      //         Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
      //       }
      //     });
      // } else {
      //   //注文台帳編集保存

      //   updateSendDetail({
      //     sendBasicForm: this.sendEditForm,
      //     sendDetailList: this.sendDetailData,
      //   })
      //     .then((res) => {
      //       Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
      //       this.outputProcess();
      //     })
      //     .catch((err) => {
      //       this.showFlag = false;
      //       if (err.data != null) {
      //         Message.showError(
      //           t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
      //         );
      //       } else {
      //         Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
      //       }
      //     });
      // }

      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      //出荷残<0
      // let disSendNumCheckFlg = this.sendDetailTable.some(function (item) {
      //   return item.sdSendRemainQty < 0;
      // });

      // if (disSendNumCheckFlg) {
      //   let message = t("message.SEND.DIS_SEND_QTY_CONFIRM");

      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.saveDataAndOutput(1);
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      //   this.saveDataAndOutput(1);
      // }

      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // //未納品<0
      // let disSendQtyFlg = this.sendDetailTable.some(function (item) {
      //   return item.disSendNum < 0;
      // });

      // if (disSendQtyFlg) {
      //   let message = t("message.SEND.NOT_SEND_QTY_CONFIRM");
      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.outputAcceptQtyCheck(1);
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      //   this.outputAcceptQtyCheck(1);
      // }
      this.saveDataAndOutput(1);
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // UPD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    // saveDataAndOutput(kbn) {
    saveDataAndOutput(kbn, row) {
      // UPD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑

      this.dataAddUpdProc();

      //注文台帳編集保存
      updateSendDetail({
        sendBasicForm: this.sendEditForm,
        sendDetailList: this.sendDetailData,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          if (kbn == 1) {
            this.outputProcess();
          } else if (kbn == 2) {
            // UPD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
            // 課題_納期分割機能の追加
            //this.showErrorDialogProc();
            this.showDueDateEditDialogProc(row);
            // UPD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑
          }
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          else if (kbn == 3) {
            this.outputRedProcess();
          }
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    outputProcess() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      let existData = this.sendDetailTable.filter(
        (item) => item.sdDeliveryNoteOutBool
      );
      outputExcelToZip(httpApi.OutPutDeliveryReceiptExcel, {
        sendDetailList: existData,
        outputExcelForm: {
          sbSendNo: this.sendEditForm.sbSendNo,
          sbCusName: this.sendEditForm.sbCusCode,
        },
        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
        // })
      })
        .then(() => {
          // 出力が成功の場合、手配状態が「手配済み」を変更
          updateStatusAfterOutput({
            statusName: "sbSendStatus",
            dataNo: this.sendEditForm.sbSendNo,
          }).then(() => {
            this.numLoads = 1;
            //検索処理を行う
            this.searchSendDetailByNoProc();
          });
        })

        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑
        .finally(() => {
          this.showFlag = false;

          //検索処理を行う
          this.searchSendDetailByNoProc();
        });
    },

    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
    // 課題_納期分割機能の追加
    // 赤伝票出力
    outputRedExcel() {
      if (typeof this.$refs.redTicketBtn !== "undefined") {
        // フォーカス削除
        this.$refs.redTicketBtn.$el.blur();
      }

      if (!this.showFlag) {
        this.showFlag = true;
      }

      for (let index = 0; index < this.sendDetailTable.length; index++) {
        const element = this.sendDetailTable[index];
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 納品数＞受注数・納品数？＞運送中数＋日本入荷数の場合、保存後、日本入荷データと入荷異常データ履歴を影響
        // 納品数＜受注数・納品数<運送中数＋日本入荷数のチェックの追加
        // if (element.sdSendQty <= 0) {
        if (
          element.sdSendQty <= 0 ||
          element.disSendNum < 0 ||
          element.sendRemainSum < 0
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.SEND.SEND_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          this.showFlag = false;
          return;
        }
      }

      if (this.sendErrCloseData.length <= 0) {
        Modal.showWarning("", t("message.SEND.OUTPUT_NG_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        this.showFlag = false;
        return;
      }

      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      //未納品<0
      // let disSendQtyFlg = this.sendDetailTable.some(function (item) {
      //   return item.disSendNum < 0;
      // });

      // if (disSendQtyFlg) {
      //   let message = t("message.SEND.NOT_SEND_QTY_CONFIRM");
      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.outputAcceptQtyCheck(3);
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      //   this.outputAcceptQtyCheck(3);
      // }
      this.saveDataAndOutput(3);
      // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
    },

    outputRedProcess() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      outputExcelToZip(httpApi.OutPutSendErrExcel, {
        sbSendNo: this.sendEditForm.sbSendNo,
        sbCusName: this.sendEditForm.sbCusCode,
      })
        .then(() => {
          this.numLoads = 1;
          //検索処理を行う
          this.searchSendDetailByNoProc();
        })

        // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑
        .finally(() => {
          this.showFlag = false;

          //検索処理を行う
          this.searchSendDetailByNoProc();
        });
    },
    // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

    // 製品異常
    rowClassName({ row }) {
      if (!!row.sdProdExKbn && row.sdProdExKbn != STR_EMPTY) {
        if (row.sdProdExKbn == NUM_TWO) {
          return "textColor";
        }
      }
    },

    // DEL 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
    // // 納品異常処理画面
    // sendErrorDialogProc() {
    //   if (typeof this.$refs.sendErrBtn !== "undefined") {
    //     // フォーカス削除
    //     this.$refs.sendErrBtn.$el.blur();
    //   }

    //   // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //   if (!this.sendDetailTable || this.sendDetailTable.length <= 0) {
    //     Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
    //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
    //     });
    //     this.showFlag = false;
    //     return;
    //   }
    //   for (let index = 0; index < this.sendDetailTable.length; index++) {
    //     const element = this.sendDetailTable[index];
    //     //   if (
    //     //     element.sdSendQty <= 0 ||
    //     //     element.sdSendQty >
    //     //       element.transportingQty +
    //     //         element.jrdReceQty -
    //     //         element.sdProCompleteNum
    //     //   ) {
    //     //     let message =
    //     //       "製品「" +
    //     //       element.aodProdName +
    //     //       "」の" +
    //     //       t("message.SEND.SEND_QTY_CHECK");
    //     //     Modal.showWarning("", message, {
    //     //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
    //     //     });
    //     //     return;
    //     //   }

    //     if (element.sdSendQty <= 0) {
    //       let message =
    //         "製品「" +
    //         element.aodProdName +
    //         "」の" +
    //         t("message.SEND.SEND_QTY_CHECK");
    //       Modal.showWarning("", message, {
    //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
    //       });
    //       this.showFlag = false;
    //       return;
    //     }

    //     //納品NG数<納品数
    //     if (element.sdSendQty - element.sdProdExQty < 0) {
    //       let message =
    //         "製品「" +
    //         element.aodProdName +
    //         "」の" +
    //         t("message.SEND.CONFIRM_CHECK");
    //       Modal.showWarning("", message, {
    //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
    //       });
    //       return;
    //     }
    //     // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    //   }
    //   // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    //   // //保存前、データ処理
    //   // this.dataAddUpdProc();
    //   // //注文台帳編集保存
    //   // updateSendDetail({
    //   //   sendBasicForm: this.sendEditForm,
    //   //   sendDetailList: this.sendDetailData,
    //   // })
    //   //   .then((res) => {
    //   //     Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
    //   //     this.showErrorDialogProc();
    //   //   })
    //   //   .catch((err) => {
    //   //     this.showFlag = false;
    //   //     if (err.data != null) {
    //   //       Message.showError(
    //   //         t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
    //   //       );
    //   //     } else {
    //   //       Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
    //   //     }
    //   //   });

    //   // 出荷残<0
    //   let disSendNumCheckFlg = this.sendDetailTable.some(function (item) {
    //     return item.sdSendRemainQty < 0;
    //   });

    //   if (disSendNumCheckFlg) {
    //     let message = t("message.SEND.DIS_SEND_QTY_CONFIRM");

    //     Modal.showWarning("", message, {
    //       $type: "prompt",
    //       confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
    //       cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
    //       showCancelButton: true,
    //     })
    //       .then(() => {
    //         this.saveDataAndOutput(2);
    //       })
    //       .finally(() => {
    //         if (this.showFlag) {
    //           this.showFlag = false;
    //         }
    //       });
    //   } else {
    //     this.saveDataAndOutput(2);
    //   }
    //   // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    // },

    // showErrorDialogProc() {
    //   ShowSendErrorDialog(
    //     {
    //       sendEditForm: this.sendEditForm,
    //       sendDetailTable: this.sendDetailTable,
    //     },
    //     t("resource.SEND.SEND_ERROR_DIALOG"),
    //     () => {
    //       this.numLoads = 1;
    //       this.searchSendDetailByNoProc();
    //     }
    //   );
    // },
    // DEL 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

    //セルデータの保存
    changeCellData(row) {
      row.sdSendQty = this.checkNull(row.sdSendQty);
      //加工単価が数字の場合
      if (!isNaN(row.sdUSalesPrice)) {
        if (row.sdProdExKbn == STR_ZERO) {
          // 小計
          row.sdTotalSalesShow = formatStringToCurrency(
            row.sdUSalesPrice * row.sdSendQty
          );
          row.sdTotalSales = row.sdUSalesPrice * row.sdSendQty;

          // 売価
          row.sdUSalesPriceShow = formatStringToCurrency(row.sdUSalesPrice);
        } else {
          row.sdTotalSalesShow = STR_HYPHEN;
          row.sdUSalesPriceShow = STR_HYPHEN;
          row.sdTotalSales = 0;
        }

        // 売価
        row.sdUSalesPriceShow = formatStringToCurrency(row.sdUSalesPrice);
      } else {
        //売価が数字以外の場合、0に表示する
        row.sdUSalesPrice = 0;
        row.sdTotalSalesShow = formatStringToCurrency(0);
        row.sdTotalSales = 0;
      }

      // 運送中
      row.transportingQty = this.checkNull(row.transportingQty);
      // 日本入荷数
      row.jrdReceQty = this.checkNull(row.jrdReceQty);
      // 出荷完了
      row.sdProCompleteNum = this.checkNull(row.sdProCompleteNum);

      // 未出荷: 運送中+事務所入荷-出荷完了の合計-本回出荷数
      row.disSendNum =
        row.transportingQty +
        row.jrdReceQty -
        row.sdProCompleteNum -
        row.sdSendQty;

      if (row.sdProdExKbn == STR_ZERO) {
        // 出荷残：受注数-出荷完了数-本回出荷数
        row.sdSendRemainQty =
          row.aodProdQuantity - row.sdProCompleteNum - row.sdSendQty;
      } else {
        row.sdSendRemainQty = NUM_ZERO;
      }
      // this.$set(this.sendDetailTable, row.index, row);
      // setColumnWidth(this.columns, this.sendDetailTable);
      this.dataProcess();
    },

    noteOutputProc(row) {
      this.sdDeliveryNoteData[row.index] = row.sdDeliveryNoteOutBool;
      this.updateTotalQty();
    },

    updateTotalQty() {
      //本回出荷合計のクリア
      this.sendQtySum = NUM_ZERO;
      //金額合計のクリア
      this.amountTotal = NUM_ZERO;
      //出荷残合計のクリア
      this.sendRemainSum = NUM_ZERO;

      if (this.sendDetailTable.length >= 1) {
        this.sendDetailTable.map((item) => {
          //加工単価が数字の場合
          if (!isNaN(item.sdUSalesPrice)) {
            //金額合計
            if (!!!this.amountTotal || this.amountTotal == STR_EMPTY) {
              this.amountTotal = NUM_ZERO;
            }
            if (!!item.sdTotalSales && item.sdTotalSales != NUM_ZERO) {
              this.amountTotal = formatStringToCurrency(
                formatCurrencyToNumber(this.amountTotal) + item.sdTotalSales
              );
            }
          }
          //本回出荷合計
          if (!!!this.sendQtySum || this.sendQtySum == STR_EMPTY) {
            this.sendQtySum = NUM_ZERO;
          }
          if (!!item.sdSendQty) {
            this.sendQtySum += item.sdSendQty;
          }

          //出荷残合計
          if (!!!this.sendRemainSum || this.sendRemainSum == STR_EMPTY) {
            this.sendRemainSum = NUM_ZERO;
          }
          if (!!item.sdSendRemainQty) {
            this.sendRemainSum = this.sendRemainSum + item.sdSendRemainQty;
          }
          return item;
        });
      }
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      let columnIndex = this.editableColumns.indexOf(columnProp);

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      index = index + 1;

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      let dataSize = this.sendDetailTable.length;

      for (let num = 0; num < this.sendDetailTable.length; num++) {
        const element = this.sendDetailTable[num];
        dataSize += element.childrenCount ?? 0;
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      if (index > dataSize - 1) {
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // this.$refs[`input${0}`][columnIndex].focus();
        for (var i = 0; i < dataSize; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      } else {
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // this.$refs[`input${index}`][columnIndex].focus();
        var i = index;
        for (i; i < dataSize; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == dataSize) {
          const firstRef = this.$refs[`input0-${columnProp}`];
          if (firstRef && firstRef[0]) firstRef[0].focus();
          return;
        }
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      }
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // ボタン
      const errBtnColumn = columnIndex === this.columns.length;

      var msmColumnColorFlg =
        row.id >= 10000 &&
        row.dataKbn === STR_ONE &&
        ((column.property == "sdQuoteNo" && !row.sdQuoteNo) || // 見積No.
          (column.property == "aodUrgent" && !row.aodUrgent) || // 緊急度
          errBtnColumn ||
          (column.property == "sdSendQty" && !row.sdSendQty) || // 本回出荷数
          (column.property == "aodCusDelvName" && !row.aodCusDelvName) || // 得意先納品先
          (column.property == "sdDeliveryNoteOut" && !row.sdDeliveryNoteOut) || // 納品書出力
          column.property == "sdUSalesPriceShow" || // 売価
          column.property == "sdTotalSalesShow" || // 小計
          (column.property == "aodCusDeliveryDate" &&
            !row.aodCusDeliveryDate) || // 得意先納期
          (column.property == "sbCusCode" && !row.sbCusCode) || // 得意先
          (column.property == "aobCusUserCode" && !row.aobCusUserCode) || // 得意先担当者
          (column.property == "aodProdQuantity" && !row.aodProdQuantity) || // 受注数
          (column.property == "aodProdUnit" && !row.aodProdUnit) || // 単位
          (column.property == "transportingQty" && !row.transportingQty) || // 運送中
          (column.property == "jrdReceQty" && !row.jrdReceQty) || // 日本入荷数
          (column.property == "sdProCompleteNum" && !row.sdProCompleteNum) || // 出荷完了
          (column.property == "disSendNum" && !row.disSendNum) || // 未出荷
          (column.property == "sdSendRemainQty" && !row.sdSendRemainQty) || // 出荷残
          (column.property == "aobAcceptDate" && !row.aobAcceptDate) || // 受注日
          (column.property == "odDueDate" && !row.odDueDate) || // 仕入先納期
          (column.property == "aodCusOrderNo" && !row.aodCusOrderNo)); // 注番

      //ミスミ_子データの場合
      if (msmColumnColorFlg) {
        return "bg-cell-editable_grey";
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      var columnEditable = ["sdSendQty", "sdDeliveryNoteOut", "sdRemarks"];

      if (
        columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        if (this.localIsAdd) {
          return "bg-cell-editable";
        }

        if (column.property == "sdDeliveryNoteOut") {
          return "bg-cell-editable";
        }

        if (this.sendEditForm.sbDelFlg !== STR_ONE) {
          return "bg-cell-editable";
        }
      }
    },

    //セルデータの編集
    editCellData(row, column) {
      //請求の出荷情報編集不可(クローズ数が編集可); クローズ数:正常製品入力可能、異常製品入力不可

      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
      // ミスミ子データが入力不可
      if (row.id >= 1000) {
        return false;
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

      // 納品書出力
      if (column.prop === "sdDeliveryNoteOut") {
        return false;
      }
      // 備考
      if (column.prop === "sdRemarks") {
        return false;
      }

      if (!this.editableColumns.includes(column.prop)) {
        return false;
      }
      if (this.localIsAdd) {
        return true;
      }

      if (this.sendEditForm.sbDelFlg === STR_ONE) {
        return false;
      }

      return true;
    },

    checkNull(val) {
      if (!!!val || val == STR_EMPTY) {
        val = NUM_ZERO;
      }
      return val;
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.localIsAdd) {
        isDataChanged = this.sendDetailTable.length > 0;
      } else {
        isDataChanged =
          !cmpBasicData(
            this.cmpBasicResult,
            this.extractBasic(this.sendEditForm)
            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
            // ) || !cmpDetailData(this.cmpDetailResult, this.sendDetailTable);
          ) ||
          !cmpDetailData(
            this.cmpDetailResult,
            this.extractDetail(this.sendDetailTable)
          );
        // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    extractBasic(data) {
      return {
        sbCusCodeShow: data.sbCusCodeShow,
        sbCusCode: data.sbCusCode,
        sbUserCode: data.sbUserCode,
        sbSendStatus: data.sbSendStatus,
        sbSendDate: formatDateToString(data.sbSendDate),
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_納品製品選択画面の検索条件の変更
        // sbSendFlg: this.sbSendFlg,
        // sbDeliveryNoteFlg: this.sbDeliveryNoteFlg,
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        sbRemarks: data.sbRemarks,
      };
    },

    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          sdQuoteNo: item.sdQuoteNo, // 見積NO.
          sdProdNo: item.sdProdNo, // 見積明細NO.

          transportingQty: item.transportingQty, // 運送中
          jrdReceQty: item.jrdReceQty, // 日本入荷数
          sdProCompleteNum: item.sdProCompleteNum, // 出荷完了
          disSendNum: item.disSendNum, // 未納品
          sdSendRemainQty: item.sdSendRemainQty, // 出荷残
          sdSendQty: item.sdSendQty, // 本回納品数
        };
      });
    },
    // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
    showDueDateEditDialogBeforeProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();

      for (let index = 0; index < this.sendDetailTable.length; index++) {
        const element = this.sendDetailTable[index];

        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 納品数＞受注数・納品数？＞運送中数＋日本入荷数の場合、保存後、日本入荷データと入荷異常データ履歴を影響
        // 納品数＜受注数・納品数<運送中数＋日本入荷数のチェックの追加
        // if (element.sdSendQty <= 0) {
        if (
          element.sdSendQty <= 0 ||
          element.disSendNum < 0 ||
          element.sendRemainSum < 0
        ) {
          // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          let message =
            "製品「" +
            element.aodProdName +
            "」の" +
            t("message.SEND.SEND_QTY_CHECK");
          Modal.showWarning("", message, {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          this.showFlag = false;
          return;
        }
      }

      // DEL 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓

      // //出荷残<0
      // let disSendNumCheckFlg = this.sendDetailTable.some(function (item) {
      //   return item.sdSendRemainQty < 0;
      // });

      // if (disSendNumCheckFlg) {
      //   let message = t("message.SEND.DIS_SEND_QTY_CONFIRM");

      //   Modal.showWarning("", message, {
      //     $type: "prompt",
      //     confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
      //     cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
      //     showCancelButton: true,
      //   })
      //     .then(() => {
      //       this.saveDataAndOutput(2, row);
      //     })
      //     .finally(() => {
      //       if (this.showFlag) {
      //         this.showFlag = false;
      //       }
      //     });
      // } else {
      // DEL 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      this.saveDataAndOutput(2, row);
      // }
    },
    // 異常製品追加画面
    showDueDateEditDialogProc(row) {
      ShowDueDateEditDialog(
        {
          isKbn: STR_FIVE,
          rowData: row,
          procKbn: row.procKbn,
          aobQuoteNo: row.sdQuoteNo,
          aodDataProdNo: row.sdProdNo,
          sbSendNo: row.sdSendNo,
          sdSendDetailNo: row.sdSendDetailNo,
          // odOrderNo: row.jrdOrderNo,
        },
        t("resource.DUE_DATE_EDIT.ERR_PROD_ADD"),

        (target) => {
          // 注文No.による注文詳細情報の取得
          this.searchSendDetailByNoProc();
        }
      );
    },
    // ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑

    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 start↓
    //「再度納品」機能の追加
    sendAgain() {
      //画面データに変更があるかどうかを判断する
      let isDataChanged = false;
      isDataChanged =
        !cmpBasicData(
          this.cmpBasicResult,
          this.extractBasic(this.sendEditForm)
        ) ||
        !cmpDetailData(
          this.cmpDetailResult,
          this.extractDetail(this.sendDetailTable)
        );

      //変更があった場合、メッセージ「データが変更されましたが、まず現在のデータを保存してください」を表示する
      if (isDataChanged) {
        let message = t("message.SEND.DATA_ALREADY_CHANGED_SAVE_FIRST");
        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      } else {
        //画面を新規状態にする

        this.showFlag = true;
        this.localIsAdd = true;
        // 読み込み回数
        this.numLoads = 1;

        this.activeNames = ["sendBasic"];
        this.handleCollapseChange(this.activeNames);

        (this.sendEditForm = {
          sbSendNo: "", //納品No
          sbCusCodeShow: "", //得意先
          sbCusCode: "", //得意先
          sbUserCode: getUserInfo().UserId, //担当者:ログインユーザー
          sbSendStatus: STR_ONE, //状態：新規
          sbSendDate: new Date(), //納品日:システム日
          sbRequestExpectedDate: "", // 請求予定日
          sbRequestStatus: STR_ONE, // 請求状態
          sbRemarks: "", // 備考
          sbUpdateUser: "", // 担当者
          sbUpdateTime: "", //更新者
          sbUpdateTime: "", //更新時刻
        }),
          this.getAbleList();
        this.cusCalculateDate = 0;
        (this.sendDetailTable = []),
          (this.sendQtySum = 0), //本回出荷合計
          (this.sendRemainSum = 0), //出荷残合計
          (this.amountTotal = 0), //金額合計
          (this.confirmBtnFlg = true); // 「納品書&受領書」ボタン：クリック不可
        this.btnSendSelectFlag = false; //「納品製品選択」ボタン:クリック可能

        this.showFlag = false;
      }
    },
    // ADD 2026/04/20 Wjx 課題_顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
.editInput {
  width: 90%;
  height: 17px;
}
/* ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ */
::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
/* ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ */
</style>
